// CHỜ GIỮA CÁC LẦN (06/10/2026 — người dùng: "đăng nhiều bình luận / tham gia nhiều nhóm chạy quá nhanh vì không có ô chỉnh khoảng chờ").
// Mọi bước LẶP (nhiều bài / nhóm / video / lượt trong một bước) nhận cặp tham số tuỳ chọn "Chờ giữa các lần: từ ___ đến ___ giây":
//  · lưu thành hai tham số cho_tu_giay / cho_den_giay của khối; lúc lắp chuyển thành tham số kịch bản `cho_giua_<bước>_tu|den` + trường `cho_giua` của bước LẶP
//    trong phần đã học (BundleStep.cho_giua) — CHỈ khi người dùng điền (bỏ trống = bundle / hash y như cũ, runner dùng nhịp cũ: nghỉ giữa mục + Cài đặt nhịp đăng);
//  · runner chờ NGẪU NHIÊN trong khoảng đó trước mỗi mục (không chờ trước mục đầu / sau mục cuối), ngắt được khi Dừng (src/background/runner.ts motMuc).
// Module THUẦN, dùng chung trang soạn (kiểm + lời khuyên), máy chủ (kiểm lúc lưu / lắp), runner (tính thời gian chờ).
import type { KhoiMau, KhoiThamSo } from "./tu-dung";

export const TS_CHO_TU = "cho_tu_giay";
export const TS_CHO_DEN = "cho_den_giay";
export const TRAN_CHO_GIAY = 86_400; // 24 giờ
export const NGUONG_NHANH_GIAY = 3; // đăng / tham gia mà chờ dưới mức này: cảnh báo mềm (vẫn cho lưu)

export type LoaiViecCho = "dang" | "tham_gia" | "thich" | "xem";
interface ThongSoLoai {
  nhan: string;
  tu: number; den: number; // mặc định ĐỀ XUẤT (hiện sẵn khi thêm bước mới)
  khuyenTu: number; khuyenDen: number; // khoảng KHUYÊN DÙNG của cả hai ô
  nhanh: boolean; // loại việc nhạy cảm (đăng / tham gia) — cảnh báo mềm nếu < NGUONG_NHANH_GIAY
  lyDo: string;
}
// Lý do chọn số (docs/ra-soat-thoi-gian-cho.md): cẩm nang đăng bài an toàn (nghỉ vài chục giây giữa các bình luận, 5–8 bình luận / ngày, 1–3 nhóm mới / ngày),
// nhật ký thử thực tế 05–06/10 (bình luận YouTube bị ẩn; nhóm Facebook cần quản trị duyệt), nhịp đăng mặc định của bot 20–60 s.
export const CHO_THEO_LOAI: Readonly<Record<LoaiViecCho, ThongSoLoai>> = {
  dang: { nhan: "bình luận / trả lời / đăng bài", tu: 60, den: 180, khuyenTu: 20, khuyenDen: 900, nhanh: true, lyDo: "người thật không gửi hai bình luận cách nhau vài giây; nhịp đăng mặc định của bot là 20–60 giây — bình luận chờ gấp ~3 lần" },
  tham_gia: { nhan: "xin vào nhóm", tu: 120, den: 300, khuyenTu: 60, khuyenDen: 1800, nhanh: true, lyDo: "cẩm nang: tối đa 1–3 nhóm mới mỗi ngày; xin vào dồn dập là dấu hiệu tự động hoá rõ nhất" },
  thich: { nhan: "thích / theo dõi", tu: 5, den: 20, khuyenTu: 3, khuyenDen: 120, nhanh: false, lyDo: "thao tác nhẹ, người thật bấm Thích cách nhau vài giây tới vài chục giây" },
  xem: { nhan: "xem / lướt / đọc", tu: 5, den: 15, khuyenTu: 3, khuyenDen: 120, nhanh: false, lyDo: "chuyển sang mục kế sau khi đã xem xong mục trước; thời gian xem mỗi mục đã có ô riêng" },
};

/** Bước LẶP của một khối nhận ô "Chờ giữa các lần". buoc = id bước CẤP ĐẦU (trong yamlSteps) có for_each làm việc trên trang. */
export interface CauChoGiua { buoc: string; loai: LoaiViecCho; cha?: string } // cha: bước con lồng trong vòng của bước cha (phần đã học ở learned[cha].con)
/**
 * BẢNG RÀ SOÁT: mọi khối có vòng lặp làm việc trên trang → bước lặp + loại việc. Thêm khối lặp mới = thêm dòng ở đây (test cho-giua-lan kiểm đủ).
 * Khoá = "<mạng>/<khối>". Khối KHÔNG có trong bảng: không lặp nhiều lần (làm đúng một mục: bình luận một bài, thích một video…) hoặc chỉ đọc (tìm, lấy danh sách).
 */
export const CHO_THEO_KHOI: Readonly<Record<string, CauChoGiua>> = {
  "facebook/binh_luan_bai": { buoc: "dang_binh_luan", loai: "dang" },
  "facebook/tham_gia_nhom": { buoc: "tham_gia_nhom", loai: "tham_gia" },
  "facebook/thich_bai": { buoc: "thich_bai", loai: "thich" },
  "facebook/luot_bang_tin": { buoc: "thich_khi_luot", loai: "thich" },
  "facebook/tra_loi_binh_luan_bai_minh": { buoc: "gui_tl_minh", loai: "dang", cha: "vong_bai_minh" },
  "tiktok/binh_luan": { buoc: "dang_binh_luan", loai: "dang" },
  "tiktok/tra_loi_binh_luan": { buoc: "gui_tra_loi", loai: "dang" },
  "tiktok/tra_loi_binh_luan_kenh_minh": { buoc: "tra_loi_bl_tt", loai: "dang", cha: "tra_loi_video_tt" }, // vòng trả lời nằm TRONG vòng video của kênh mình
  "youtube/tra_loi_binh_luan_kenh_minh": { buoc: "tra_loi_bl_kenh", loai: "dang", cha: "tra_loi_video_kenh" },
  "tiktok/luot_video": { buoc: "luot_xem_video", loai: "xem" },
  "tiktok/luot_de_xuat": { buoc: "luot_de_xuat_vong", loai: "xem" },
  "youtube/binh_luan": { buoc: "dang_binh_luan", loai: "dang" },
  "youtube/tra_loi_binh_luan": { buoc: "gui_tra_loi", loai: "dang" },
  "youtube/luot_video": { buoc: "luot_xem_video", loai: "xem" },
  "youtube/luot_shorts": { buoc: "luot_shorts_vong", loai: "xem" },
  "x/tra_loi": { buoc: "gui_tra_loi", loai: "dang" },
  "x/tra_loi_phan_hoi": { buoc: "gui_phan_hoi", loai: "dang" },
  "x/luot_bang_tin": { buoc: "doc_bang_tin", loai: "xem" },
  "reddit/tim_roi_binh_luan": { buoc: "gui_bl_rd", loai: "dang" },
  "reddit/doc_bai": { buoc: "doc_bai_tim", loai: "xem" },
  // 07/10/2026 — chủ kênh thả tim / thích nhiều bình luận dưới video của mình (vòng nằm TRONG vòng video)
  "youtube/tim_ghim_binh_luan": { buoc: "tha_tim_bl_yt", loai: "thich", cha: "vong_video_tg_yt" },
  "tiktok/tim_ghim_binh_luan": { buoc: "thich_bl_tt", loai: "thich", cha: "vong_video_tg_tt" },
  // (07/10/2026, nhóm 4) Trả lời tin nhắn chưa đọc: vòng đoạn chat — chờ giữa hai tin gửi đi như người thật.
  "facebook/tra_loi_tin_nhan": { buoc: "tra_loi_chat_fb", loai: "dang" },
  "tiktok/tra_loi_tin_nhan": { buoc: "tra_loi_chat_tt", loai: "dang" },
};

const dem = (s: string): number => Array.from(s).length;
const tenThamSoKichBan = (buoc: string, canh: "tu" | "den"): string => `cho_giua_${buoc}_${canh}`;

/** Hai tham số của khối (tuỳ chọn, bỏ trống = nhịp cũ). goiY = số hiện sẵn khi THÊM bước mới (không phải mặc định lúc lắp — sơ đồ cũ giữ nguyên). */
export function thamSoChoGiua(loai: LoaiViecCho): [KhoiThamSo, KhoiThamSo] {
  const c = CHO_THEO_LOAI[loai];
  // min/max = trần KỸ THUẬT (0–24 giờ) để ô không hiện lời khuyên chung; lời khuyên riêng của loại việc nằm ở kiemKhoangCho.
  const chung = { kieu: "so" as const, anKhiRong: true, min: 0, max: TRAN_CHO_GIAY };
  return [
    { ten: TS_CHO_TU, moTa: `chờ ít nhất bao nhiêu GIÂY giữa hai lần ${c.nhan} (ngẫu nhiên trong khoảng từ–đến; bỏ trống cả hai = nhịp mặc định của bot; tối đa ${TRAN_CHO_GIAY})`, goiY: String(c.tu), ...chung },
    { ten: TS_CHO_DEN, moTa: `chờ nhiều nhất bao nhiêu GIÂY giữa hai lần ${c.nhan} (không nhỏ hơn "từ"; tối đa ${TRAN_CHO_GIAY})`, goiY: String(c.den), ...chung },
  ];
}

/**
 * Gắn "Chờ giữa các lần" vào khối: + hai tham số, + tham số kịch bản `cho_giua_<bước>_tu|den`, + trường `cho_giua` trong phần đã học của bước lặp.
 * Khối không có bước đó / đã gắn rồi → trả nguyên khối. (Các khối là DỮ LIỆU thuần — trả bản mới, không sửa đầu vào.)
 */
export function themChoGiua(k: KhoiMau, cau: CauChoGiua): KhoiMau {
  if (k.thamSo.some((t) => t.ten === TS_CHO_TU)) return k;
  if (!new RegExp(`^\\s*- id:\\s*${cau.buoc}\\s*$`, "m").test(k.yamlSteps)) throw new Error(`khối '${k.ten}' không có bước '${cau.buoc}' để gắn "chờ giữa các lần"`);
  const [tu, den] = thamSoChoGiua(cau.loai);
  const nhan = CHO_THEO_LOAI[cau.loai].nhan;
  const params = {
    ...(k.params ?? {}),
    [tenThamSoKichBan(cau.buoc, "tu")]: { type: "number", default: `{{ts.${TS_CHO_TU}}}`, label: `Chờ giữa các lần ${nhan} — từ (giây)` },
    [tenThamSoKichBan(cau.buoc, "den")]: { type: "number", default: `{{ts.${TS_CHO_DEN}}}`, label: `Chờ giữa các lần ${nhan} — đến (giây)` },
  };
  const choGiua = { tu: `{{${tenThamSoKichBan(cau.buoc, "tu")}}}`, den: `{{${tenThamSoKichBan(cau.buoc, "den")}}}` };
  let learned: Record<string, unknown>;
  if (cau.cha) {
    // bước con: phần đã học nằm ở learned[cha].con[bước] (tu-dung.ts gopDaHoc)
    const cha = (k.learned[cau.cha] ?? {}) as { con?: Record<string, unknown> } & Record<string, unknown>;
    const hienCo = (cha.con?.[cau.buoc] ?? {}) as Record<string, unknown>;
    learned = { ...k.learned, [cau.cha]: { ...cha, con: { ...(cha.con ?? {}), [cau.buoc]: { ...hienCo, cho_giua: choGiua } } } };
  } else {
    const hienCo = (k.learned[cau.buoc] ?? {}) as Record<string, unknown>;
    learned = { ...k.learned, [cau.buoc]: { ...hienCo, cho_giua: choGiua } };
  }
  return { ...k, thamSo: [...k.thamSo, tu, den], params, learned };
}

/** Gắn cho cả bảng khối của một mạng (khoá `${ma}/${tên khối}` trong CHO_THEO_KHOI). */
export function themChoGiuaChoMang(ma: string, ds: KhoiMau[]): KhoiMau[] {
  return ds.map((k) => { const c = CHO_THEO_KHOI[`${ma}/${k.ten}`]; return c ? themChoGiua(k, c) : k; });
}

/** Có đặt "Chờ giữa các lần" (ít nhất một ô) trong giá trị ts của khối không. */
export const coChoGiua = (ts: Record<string, string | undefined>): boolean => !!(ts[TS_CHO_TU] ?? "").trim() || !!(ts[TS_CHO_DEN] ?? "").trim();
/** Chỉ điền một ô → ô kia tự lấy: "từ" một mình → "đến" = "từ"; "đến" một mình → "từ" = 0. Đủ hai ô / trống cả hai → nguyên. Không sửa đầu vào. */
export function chuanChoGiuaTs<T extends Record<string, string | undefined>>(ts: T): T {
  const a = (ts[TS_CHO_TU] ?? "").trim(), b = (ts[TS_CHO_DEN] ?? "").trim();
  if (!!a === !!b) return ts;
  return { ...ts, [TS_CHO_TU]: a || "0", [TS_CHO_DEN]: b || a };
}

/**
 * Lúc LẮP (sinhKichBan): bỏ `cho_giua` khỏi phần đã học khi người dùng không đặt → bundle y như trước khi có tính năng (hash không đổi, plugin cũ chạy như cũ).
 * Trả bản đã lọc (không sửa đầu vào).
 */
export function locChoGiuaLearned<T>(learned: T, bat: boolean): T {
  if (bat) return learned;
  const loc = (v: unknown): unknown => {
    if (Array.isArray(v)) return v.map(loc);
    if (!v || typeof v !== "object") return v;
    const out: Record<string, unknown> = {};
    for (const [k, x] of Object.entries(v as Record<string, unknown>)) {
      if (k === "cho_giua" && x && typeof x === "object" && "tu" in x && "den" in x) continue;
      out[k] = loc(x);
    }
    return out;
  };
  return loc(learned) as T;
}
/** Tham số kịch bản của "chờ giữa các lần" (cho_giua_<bước>_tu|den) — bỏ khi không đặt (xem locChoGiuaLearned). */
export const laThamSoKichBanChoGiua = (ten: string): boolean => /^cho_giua_[A-Za-z0-9_]+_(?:tu|den)(?:_\d+)?$/.test(ten); // (07/10/2026) lần dùng thứ n ≥ 2 mang hậu tố _n ở cuối

// ---------------------------------------------------------------- kiểm hợp lệ ----------------------------------------------------------------
export interface KetQuaKiemCho { loi: string | null; canhBao: string | null }
/**
 * Kiểm cặp "từ / đến" (chữ người dùng gõ, giây). Cả hai trống = dùng nhịp mặc định (hợp lệ). LỖI (chặn lưu): chỉ điền một ô, không phải số nguyên, âm, > 24 giờ,
 * từ > đến. CẢNH BÁO MỀM (vẫn cho lưu): đăng / tham gia mà chờ dưới 3 giây, hoặc ngoài khoảng khuyên dùng của loại việc.
 */
export function kiemKhoangCho(tu: string | undefined, den: string | undefined, loai?: LoaiViecCho): KetQuaKiemCho {
  const a = (tu ?? "").trim(), b = (den ?? "").trim();
  if (!a && !b) return { loi: null, canhBao: null };
  for (const [ten, v] of [["từ", a], ["đến", b]] as const) {
    if (!v) continue;
    if (!/^-?\d+$/.test(v)) return { loi: `Chờ giữa các lần: ô “${ten}” phải là số nguyên giây, đang là “${dem(v) > 20 ? Array.from(v).slice(0, 20).join("") + "…" : v}”`, canhBao: null };
    const n = Number(v);
    if (n < 0) return { loi: `Chờ giữa các lần: ô “${ten}” không được âm (đang là ${n})`, canhBao: null };
    if (n > TRAN_CHO_GIAY) return { loi: `Chờ giữa các lần: ô “${ten}” tối đa ${TRAN_CHO_GIAY} giây (24 giờ), đang là ${n}`, canhBao: null };
  }
  // Chỉ điền MỘT ô: ô kia tự lấy (không rỗng) — "từ" một mình = chờ đúng ngần ấy; "đến" một mình = chờ ngẫu nhiên từ 0 tới ngần ấy (chuanChoGiuaTs).
  if (!a || !b) {
    const c = chuanChoGiuaTs({ [TS_CHO_TU]: a, [TS_CHO_DEN]: b });
    return { loi: null, canhBao: `Mới điền ô “${a ? "từ" : "đến"}” — ô “${a ? "đến" : "từ"}” tự lấy ${c[a ? TS_CHO_DEN : TS_CHO_TU]} giây (chờ ${c[TS_CHO_TU] === c[TS_CHO_DEN] ? `đúng ${c[TS_CHO_TU]}` : `ngẫu nhiên ${c[TS_CHO_TU]}–${c[TS_CHO_DEN]}`} giây). Nên điền cả hai ô` };
  }
  const x = Number(a), y = Number(b);
  if (x > y) return { loi: `Chờ giữa các lần: “từ” (${x}) phải nhỏ hơn hoặc bằng “đến” (${y})`, canhBao: null };
  if (loai) {
    const c = CHO_THEO_LOAI[loai];
    if (c.nhanh && x < NGUONG_NHANH_GIAY) return { loi: null, canhBao: `Chờ chỉ ${x} giây giữa hai lần ${c.nhan} trông giống máy — dễ bị mạng xã hội hạn chế (khuyên ${c.khuyenTu}–${c.khuyenDen} giây, đề xuất ${c.tu}–${c.den}). Vẫn lưu được nếu bạn cố ý` };
    if (x < c.khuyenTu || y > c.khuyenDen) return { loi: null, canhBao: `Khuyên chờ ${c.khuyenTu}–${c.khuyenDen} giây giữa hai lần ${c.nhan} (đề xuất ${c.tu}–${c.den}) — bạn đặt ${x}–${y}` };
  }
  return { loi: null, canhBao: null };
}

/** Lỗi của cặp ô trong KẾ HOẠCH / SƠ ĐỒ (giá trị ts đã chuẩn hoá) — dùng chung máy chủ. null = hợp lệ / không đặt. */
export function loiChoGiuaTs(ts: Record<string, string | undefined>): string | null {
  return kiemKhoangCho(ts[TS_CHO_TU], ts[TS_CHO_DEN]).loi;
}

// ---------------------------------------------------------------- runner ----------------------------------------------------------------
/** Giá trị trường `cho_giua` của bước (số, chữ "60", hoặc {{…}} đã thay) → [từ, đến] giây; null = không hợp lệ / không đặt (runner dùng nhịp cũ). */
export function khoangChoTuBuoc(tu: unknown, den: unknown): [number, number] | null {
  const so = (v: unknown): number | null => {
    const n = typeof v === "number" ? v : typeof v === "string" && /^\s*-?\d+(?:\.\d+)?\s*$/.test(v) ? Number(v) : NaN;
    return Number.isFinite(n) ? n : null;
  };
  const a = so(tu), b = so(den);
  if (a === null || b === null) return null;
  const lo = Math.min(Math.max(0, a), TRAN_CHO_GIAY);
  const hi = Math.min(Math.max(lo, b), TRAN_CHO_GIAY); // từ > đến (kịch bản cũ / giao tay) → chờ đúng "từ"
  return [lo, hi];
}

/** Số mili-giây phải chờ: ngẫu nhiên đều trong [từ, đến] giây, nhân hệ số rút ngắn (Nháp / Thử định vị ×0,1; 0 = không chờ). rnd ∈ [0,1). */
export function msChoGiuaLan(k: [number, number], rnd: () => number, heSo = 1): number {
  const r = (() => { const v = rnd(); return Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0; })();
  const giay = k[0] + (k[1] - k[0]) * r;
  const he = Number.isFinite(heSo) && heSo > 0 ? Math.min(heSo, 1) : 0;
  return Math.round(giay * 1000 * he);
}
